import { render, staticRenderFns } from "./NotificacoesBoletos.vue?vue&type=template&id=cbded78e&scoped=true"
import script from "./NotificacoesBoletos.vue?vue&type=script&lang=js"
export * from "./NotificacoesBoletos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbded78e",
  null
  
)

export default component.exports